import { isStrayCypherExpr } from './stray'

/** Detail bundle for a single `:Vendor` (`$vendorId` param). */
export const PLANT_VENDOR_DETAIL_CYPHER = `
  MATCH (v:Vendor {id: $vendorId})

  CALL {
    WITH v
    OPTIONAL MATCH (manufactured:Part)-[:MANUFACTURED_BY]->(v)
    WITH v, [p IN collect(DISTINCT manufactured) WHERE p IS NOT NULL] AS manufactured
    OPTIONAL MATCH (supplied:Part)-[:SUPPLIED_BY]->(v)
    WITH manufactured, [p IN collect(DISTINCT supplied) WHERE p IS NOT NULL] AS supplied
    RETURN [p IN manufactured | { part: p, role: 'manufacturer' }] +
           [p IN supplied | { part: p, role: 'supplier' }] AS parts
  }

  CALL {
    WITH v
    OPTIONAL MATCH (equipment:Equipment)-[:HAS_PART]->(part:Part)
      -[:SUPPLIED_BY|MANUFACTURED_BY]->(v)
    RETURN [eq IN collect(DISTINCT equipment) WHERE eq IS NOT NULL] AS equipment
  }

  RETURN v, parts, equipment,
         ${isStrayCypherExpr('v', 'Vendor')} AS isStray
  LIMIT 10000
`
